import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/act-posts/",
          "title": "Post page structure"
        }}>{`A snippet`}</MDXTag>{` of a post page`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-markdown"
        }}>{`---
title:  The frontmatter field containing a post title
keywords: used for SEO
order: 20 (a number influencing document position in lists )
---

## Some post
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "ACT - a post page structure",
  "keywords": "ACT, post page",
  "menu": "act blog/posts"
};
    